<script>
    import {
        Collapse,
        Navbar,
        NavbarToggler,
        NavbarBrand,
        Nav,
        NavItem,
        NavLink
    } from '@sveltestrap/sveltestrap';

    let isOpen = false;

    function handleUpdate(event) {
        isOpen = event.detail.isOpen;
    }
</script>
<section class='mb-2'>
    <Navbar expand="md" color="dark" dark>
        <NavbarToggler on:click={() => (isOpen = !isOpen)} />
        <NavbarBrand href="/">
            <img src='/images/wpfa-logo-primary.png' class="wp-header-logo d-inline-block align-text-top" alt="WPFirstaid"/> 
            <span class='fas fa-heartbeat'></span> Workplace First Aid
        </NavbarBrand>        
        <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>           
            <Nav class="ms-auto" navbar>
                  
                <NavItem>
                    
                    <NavLink href='/login'>
                        <span class='fas fa-sign-in-alt'></span> Login
                    </NavLink>
                    
                </NavItem>                                
            </Nav>
        </Collapse>
    </Navbar>     
  </section>

  <style>
    .wp-header-logo {
        width: 45px;
        height: auto;        
    }
  </style>